<nx-accordion variant="light">
  <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
    <nx-expansion-panel-header>
      <nx-expansion-panel-title class="accordion_edit">
        <!-- Coverage -No Claim Discount -->
        Coverage
      </nx-expansion-panel-title>
    </nx-expansion-panel-header>

    <!-- <div nxLayout="grid nopadding" formGroupName="noClaimDiscountCoverage"> -->
    <ng-container>
      <div nxLayout="grid nopadding" [formGroup]="ncdForm">
          @if (!isNCDWithdraw) {
          <div nxRow>
            <div nxCol="12,12,6,6,6,6,6">
              <nx-formfield label="No Claim Discount From">
                <nx-dropdown formControlName="prevNcdInsurer" [showFilter]="true" filterPlaceholder="">
                  <nx-dropdown-item *ngFor="let item of lov.insurerList" value="{{item.code}}">
                    {{ item.descp | uppercase }}
                  </nx-dropdown-item>
                </nx-dropdown>
                <nx-error nxFormfieldError>
                  <strong>No Claim Discount From required.</strong>
                </nx-error>
              </nx-formfield>
            </div>

            <div nxCol="12,12,6,6,6,6,6">
              <nx-formfield label="No Claim Discount Vehicle No.">
                <input nxInput type="text" formControlName="ncdVehicleNo" maxlength="20" style="text-transform: uppercase;" />
                <nx-error nxFormfieldError *ngIf="ncdForm && ncdForm.get('ncdVehicleNo').hasError('required')">
                  <strong>No Claim Discount Vehicle No. required.</strong>
                </nx-error>
                <nx-error nxFormfieldError *ngIf="ncdForm && ncdForm.get('ncdVehicleNo').hasError('invalid')">
                  <strong>Invalid Vehicle No.</strong>
                </nx-error>
              </nx-formfield>
            </div>
            
          </div>
          }
          
          <div nxRow>
            <div nxCol="12,12,6,6,6,6,6">
              <nx-formfield label="No Claim Discount (%)">
                <nx-dropdown formControlName="ncdPercentage" [showFilter]="true" filterPlaceholder="">
                  <ng-container *ngFor="let discount of discountPercentageList">
                    <nx-dropdown-item [value]="discount.code">{{ discount.descp }}</nx-dropdown-item>
                  </ng-container>
                  
                </nx-dropdown>
              </nx-formfield>
            </div>
            <div nxCol="12,12,6,6,6,6,6">
              <nx-formfield label="NCD Effective Date">
                <input nxDatefield nxInput formControlName="ncdEffectiveDate" [datepicker]="myDatepicker9"
                  [parseFormat]="['MM/DD/YYYY', 'DD/MM/YYYY']" displayFormat="DD/MM/YYYY" />
                <span nxFormfieldHint>DD/MM/YYYY</span>
          
                <nx-datepicker-toggle [for]="myDatepicker9" nxFormfieldSuffix></nx-datepicker-toggle>
                <nx-datepicker #myDatepicker9></nx-datepicker>
              </nx-formfield>
            </div>
          </div>
      </div>
    </ng-container>
  </nx-expansion-panel>
</nx-accordion>